import Vue from 'vue';

let installed = false;

if (!installed) {
  /** @type {Vue.PluginObject<void>} */
  const plugin = {
    install(Vue) {
      Vue.mixin({
        created() {
          const $t = Vue.prototype.$t;
          // const { load } = useOrder()
          this.$d = (message, ...args) => {
            const v = Vue.prototype.$d.call(this, message, ...args);
            return v;
          };
          this.$n = (message, ...args) => {
            try {
              const v = Vue.prototype.$n.call(this, message, ...args);
              return v;
            } catch {
              return message;
            }
          };
          this.$t = (message, ...args) => {
            // console.log('this', this, Vue.prototype);
            // console.log('----------message', message, ...args)
            const v = $t.call(this, message, ...args);
            const lang = this.$i18n.locale;
            // console.log('翻译:', lang, '->', message, '=>', v);
            if (this.$config.trans_api) {
              if (this.$vsf.$xbuy.api && lang && message) {
                this.$vsf.$xbuy.api.transAdd({
                  name: message,
                  value: v,
                  lang: lang
                });
              }
            }
            return v;
          };
        }
      });
    }
  };
  installed = true;
  Vue.use(plugin);
}
